import { Box, Typography, Divider } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * SectionHeader component - Consistent section header styling
 * Used throughout the app for section titles
 * 
 * @param {string} title - Section title
 * @param {ReactNode} action - Optional action button/element on the right
 * @param {boolean} showDivider - Whether to show divider below (default: false)
 * @param {object} sx - Additional sx styles
 */
export const SectionHeader = ({ title, action, showDivider = false, sx = {} }) => {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: showDivider ? 2 : 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {action && <Box>{action}</Box>}
      </Box>
      {showDivider && <Divider />}
    </Box>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  showDivider: PropTypes.bool,
  sx: PropTypes.object,
}
